module.exports = __webpack_public_path__ + "img/effects_bubble_creativity.1d6268e1.png";